import React from "react";

interface BaseIconProps {
  isActive?: boolean;
  className?: string;
}

export default function AllToBack({ isActive, className }: BaseIconProps) {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="all-to-back"
    >
      <path
        d="M32.615 38H21.8449C18.8831 38 16.4598 35.5838 16.4598 32.6307V21.892C16.4598 18.9389 18.8831 16.5227 21.8449 16.5227H32.615C35.5767 16.5227 38 18.9389 38 21.892V32.6307C38 35.5838 35.5767 38 32.615 38ZM21.8449 18.3125C19.8704 18.3125 18.2549 19.9233 18.2549 21.892V32.6307C18.2549 34.5994 19.8704 36.2102 21.8449 36.2102H32.615C34.5895 36.2102 36.205 34.5994 36.205 32.6307V21.892C36.205 19.9233 34.5895 18.3125 32.615 18.3125H21.8449Z"
        fill="#343A40"
        stroke="#343A40"
        stroke-width="0.75"
      />
      <path
        d="M14.615 30.7385C11.6532 30.7385 9.22998 28.3223 9.22998 25.3692V14.6306C9.22998 11.6774 11.6532 9.26123 14.615 9.26123H25.3851C28.3469 9.26123 30.7701 11.6774 30.7701 14.6306H28.9751C28.9751 12.6618 27.3596 11.051 25.3851 11.051H14.615C12.6405 11.051 11.025 12.6618 11.025 14.6306V25.3692C11.025 27.338 12.6405 28.9488 14.615 28.9488V30.7385Z"
        fill="#343A40"
        stroke="#343A40"
        stroke-width="0.75"
      />
      <path
        d="M22.5529 5.93751C22.1041 3.70029 20.0399 2 17.7064 2H6.93629C4.24377 2 2 4.23722 2 6.92189V17.6605C2 19.9873 3.61551 22.0455 5.94903 22.4929C6.30803 22.5824 6.57728 22.5824 6.93629 22.5824H7.38504V13.5441C7.38504 11.1279 9.00055 7.45882 13.5778 7.45882C18.6039 7.45882 22.1939 7.45882 22.1939 7.45882L22.6426 7.36933V6.92189C22.6426 6.65342 22.6426 6.29546 22.5529 5.93751Z"
        fill="#343A40"
      />
    </svg>
  );
}
